<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role == 'CUSTOMER_CARE'"><a routerLink="/admin/customercareOrders/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/adminReportList/">Reports</a></li>
      <li *ngIf = "type == 'Order Detail'" class="breadcrumb-item active" aria-current="page">Order Detail</li>
      <li *ngIf = "type == 'Demand by SKU'" class="breadcrumb-item active" aria-current="page">Demand by SKU</li>
      <li *ngIf = "type == 'Product Sales'" class="breadcrumb-item active" aria-current="page">Product Sales</li>
      <li *ngIf = "type == 'Low Stock Report'" class="breadcrumb-item active" aria-current="page">Low Stock Report</li>
      <li *ngIf = "type == 'Out Of Stock Report'" class="breadcrumb-item active" aria-current="page">Out Of Stock Report</li>
      <li *ngIf = "type == 'Stock Status Report'" class="breadcrumb-item active" aria-current="page">Stock Status Report</li>
      <li *ngIf = "type == 'Returned Products list'" class="breadcrumb-item active" aria-current="page">Returned Products list</li>
      <li *ngIf = "type == 'Account Snapshot'" class="breadcrumb-item active" aria-current="page">Account Snapshot</li>
      <li *ngIf = "type == 'Products'" class="breadcrumb-item active" aria-current="page">Products</li>
      <li *ngIf = "type == 'Order all details'" class="breadcrumb-item active" aria-current="page">Order all details</li>
      <li *ngIf = "type == 'Customer details'" class="breadcrumb-item active" aria-current="page">Customer details</li>
      <li *ngIf = "type == 'Inventory Adjustments'" class="breadcrumb-item active" aria-current="page">Inventory Adjustments</li>
      <li *ngIf = "type == 'Account Owner Details'" class="breadcrumb-item active" aria-current="page">Account Owner Details</li>
      <li *ngIf = "type == 'Warehouse'" class="breadcrumb-item active" aria-current="page">Warehouse</li>
      <li *ngIf = "type == 'Report'" class="breadcrumb-item active" aria-current="page">Report</li>
      <li *ngIf = "type == 'Incoming Audit Logs'" class="breadcrumb-item active" aria-current="page">Incoming Audit Logs</li>
      <li *ngIf = "type == 'Outgoing Audit Logs'" class="breadcrumb-item active" aria-current="page">Outgoing Audit Logs</li>
    </ol>
  </nav>
<!--
  <div class="row align-items-center">
    <div class="col-7">
    </div>
    <div class="col-5 text-right" *ngIf= "orderList?.length">
      <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
      <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
    </div>
  </div>
-->

  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <label class="mb-3"><b>{{type}}</b></label>
          <div class="row">
            <div class="col-md-3" *ngIf = "type !=='Account Owner Details'">
              <div class="form-group">
                <label class="control-label">Customer</label>
                <ng-select id="accountOwner" [(ngModel)]="accountOwner"
                           [ngModelOptions]="{standalone: true}" required
                           [items]="accountOwners"
                           bindLabel="ownerName"
                           bindValue="id"
                           [searchFn]="customSearchAccountOwner"
                           [searchWhileComposing]="true">
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.ownerName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                </ng-select>
              </div>
            </div>

            <div class="col-md-3" *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Incoming Audit Logs'  && type !=='Outgoing Audit Logs' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Account Snapshot' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Account Owner Details' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group">
                <label class="control-label" for="sourceType">Source Type</label>
                <select class="form-control" id="sourceType" [(ngModel)]="sourceType" [ngModelOptions]="{standalone: true}" required>
                  <option value="ALL">All</option>
                  <option value="MAGENTO">Magento</option>
                  <option value="AMAZON">Amazon</option>
                  <option value="SHOPCLUES">ShopClues</option>
                  <option value="FLIPKART">FlipKart</option>
                  <option value="SHOPIFY">Shopify</option>
                  <option value="EBAY">Ebay</option>
                  <option value="WOOCOMMERCE">WooCommerce</option>
                  <option value="SHIPPED">Shift</option>
                </select>
              </div>
            </div>

<!--
            <div class="col-md-3" *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Order Detail' && type !=='Demand by SKU' && type !=='Product Sales' && type !=='Returned Products list' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Account Owner Details' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group required">
                <label class="control-label" for="invoice">Invoice Type</label>
                <select class="form-control" id="invoice" [(ngModel)]="invoiceType" [ngModelOptions]="{standalone: true}" required>
                  <option value="WORK_ORDER">Work Order</option>
                  <option value="FULFILLMENT">Fulfilment</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!invoiceTypeError">{{invoiceTypeError}}</div>
              </div>
            </div>
-->

            <div class="col-md-3"  *ngIf = "type !=='Order Detail' && type !=='Incoming Audit Logs'  && type !=='Outgoing Audit Logs' && type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'  && type !=='Account Snapshot'  && type !=='Products'  && type !=='Order all details'  && type !=='Inventory Adjustments' && type !=='Customer details' && type !=='Account Owner Details' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group required">
                <label class="control-label" for="orderStatus">Order Status</label>
                <select class="form-control" id="orderStatus" [(ngModel)]="orderStatus" [ngModelOptions]="{standalone: true}" required>
                  <option value="SUBMITTED">Submitted</option>
                  <option value="SHIPPED">Shipped</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!orderStatusError">{{orderStatusError}}</div>
              </div>
            </div>

            <div class="col-md-3"  *ngIf = "type ==='Customer details'  || type ==='Account Owner Details'">
              <div class="form-group required">
                <label class="control-label" for="status">Status</label>
                <select class="form-control" id="status" [(ngModel)]="status" [ngModelOptions]="{standalone: true}" required>
                  <option value="ALL">All</option>
                  <option value="ACTIVE">Active</option>
                  <option value="IN_ACTIVE">In Active</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!statusError">{{statusError}}</div>
              </div>
            </div>

            <div class="col-md-3" *ngIf = "type !=='Low Stock Report' && type !=='Incoming Audit Logs'  && type !=='Outgoing Audit Logs' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list' && type !=='Order Detail' && type !=='Demand by SKU' && type !=='Product Sales' && type !=='Returned Products list' && type !=='Products' && type !=='Order all details' && type !=='Customer details' && type !=='Inventory Adjustments' && type !=='Account Owner Details' && type !=='Warehouse' && type !=='Report'">
              <div class="form-group">
                  <label class="control-label" for="payment">Payment Status</label>
                  <select class="form-control" id="payment" [(ngModel)]="paymentStatus" [ngModelOptions]="{standalone: true}" required>
                  <option value="PAID">PAID</option>
                  <option value="UNPAID">Un Paid</option>
                </select>
<!--
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!paymentStatusError">{{paymentStatusError}}</div>
-->
              </div>
            </div>


            <div class="col-md-3" *ngIf = "type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label" for="warehouseStatus">Warehouse Status</label>
                <select class="form-control" id="warehouseStatus" [(ngModel)]="warehouseStatus" [ngModelOptions]="{standalone: true}" required>
                  <option value="ACTIVE">Active</option>
                  <option value="IN_ACTIVE">In Active</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!warehouseStatusError">{{warehouseStatusError}}</div>
              </div>
            </div>
            <div class="col-md-3" *ngIf = "type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label">State</label>
                <ng-select id="State" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                           [ngClass]="{'service-error':stateError}"
                           [ngClass]="{'is-invalid':stateError}"
                           [items]="statesList"
                           placeholder="State">
                </ng-select>

                <!--
                                <input type="text" id="state" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"  class="form-control">
                -->
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!stateError">{{stateError}}</div>
              </div>
            </div>
            <div class="col-md-3" *ngIf = "type ==='Warehouse' || type ==='Report'">
              <div class="form-group required">
                <label class="control-label" for="city">City</label>
                <input type="text" id="city" [(ngModel)]="city" [ngModelOptions]="{standalone: true}"  class="form-control">
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!cityError">{{cityError}}</div>
              </div>
            </div>


          </div>

          <div class="row" *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Inventory Adjustments' && type !=='Warehouse' && type !=='Report'">
            <div class="col-md-3 required">
              <div class="form-group">
                <label class="control-label" for="fromDate">Start Date</label>
                <input type="date" id="fromDate" [(ngModel)]="startDate"
                       [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':startDateError}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!startDateError">{{startDateError}}</div>
              </div>
            </div>
            <div class="col-md-3 required">
              <div class="form-group">
                <label class="control-label" for="toDate">End Date</label>
                <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':endDateError}"
                       class="form-control" value="1">
                <div class="invalid-feedback d-block shift-invalid-login"  [hidden]="!endDateError">{{endDateError}}</div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6" style="padding-left: 30px;">
              <button type="button" routerLink="/admin/adminReportList" class="btn btn-cancel">Back</button>
            </div>
            <div class="col-6 text-right"  style="padding-right: 30px;">
              <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
              <button type="submit" (click)="submitOrder()"  class="btn btn-orange ml-2">Generate</button>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="row mt-3" *ngIf = "type =='Order Detail'">
      <div class="col-12" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"   *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
        </div>
          <table class="table">
            <tr>
              <th>Order#</th>
              <th>Warehouse Name</th>
              <th>Customer Name</th>
              <th>Contact Name</th>
              <th>Created Date</th>
              <th>Order Type</th>
              <th>Channel Name</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let od of orderList">
              <td>{{od.orderNumber}}</td>
              <td>{{od.warehouseName}}</td>
              <td>{{od.ownerName}}</td>
              <td>{{od.contactName}}</td>
              <td>{{od.createdDate}}</td>
              <td>{{od.orderType}}</td>
              <td>{{od.channelName | titlecase}}</td>
              <td>{{(od.orderStatus  == 'SUBMITTED' ? 'Submitted' : (od.orderStatus  == 'PACKER_ASSIGNED' ? 'Packer Assigned' : (od.orderStatus  == 'SPLITTED' ? 'Splitted' : (od.orderStatus  == 'CANCELLED' ? 'Cancelled' : (od.orderStatus  == 'DRAFT' ? 'Draft' : (od.orderStatus  == 'GENERATE_LABEL' ? 'Generate Label' : (od.orderStatus  == 'READY_TO_SHIP' ? 'Ready To Ship' : (od.orderStatus  == 'AWAITING_CARRIER' ? 'Awaiting Carrier' : (od.orderStatus  == 'LABEL_GENERATED' ? 'Label Generated' : (od.orderStatus  == 'COMPLETED' ? 'Completed' : (od.orderStatus  == 'TO_PACK' ? 'To Pack' : (od.orderStatus == 'PRODUCT_ALLOTTED' ? 'Product Allotted' : (od.orderStatus == 'PARTIALLY_RETURN' ? 'Partially Returned' : (od.orderStatus ==
                'TO_PICK' ? 'To Pick' : (od.orderStatus  == 'ON_HOLD' ? 'On Hold' : (od.orderStatus == 'RETURN' ? 'Returned' :  (od.orderStatus == 'PRODUCT_PACKED' ? 'Product Packed' : (od.orderStatus == 'PICK_ASSIGNED' ? 'Pick Assigned' :  od.orderStatus ))))))))))))))))))}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Incoming Audit Logs'">
      <div class="col-12" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
             <!-- <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"   *ngIf= "orderList?.length">
                <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
              </a>-->
              <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
                <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSXInboundAndOutBound()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
              </a>
              <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
                <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
                <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              </div>-->
            </div>
          </div>
          <table class="table">
            <tr>
              <th>Customer Name</th>
              <th>Method Name</th>
              <th>Count</th>
            </tr>
            <tr *ngFor="let out of orderList">
              <td>{{out.ownerName}}</td>
              <td>{{out.methodName}}</td>
              <td>{{out.noOfRecords}}</td>
            </tr>
          </table>


        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Outgoing Audit Logs'">
      <div class="col-12" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
              <!--<a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"   *ngIf= "orderList?.length">
                <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
              </a>-->
              <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf="orderList?.length">
                <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSXInboundAndOutBound()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
              </a>
              <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
                <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
                <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
              </div>-->
            </div>
          </div>
          <table class="table">
            <tr>
              <th>Customer Name</th>
              <th>Method Name</th>
              <th>Count</th>
            </tr>
            <tr *ngFor="let out of orderList">
              <td>{{out.ownerName}}</td>
              <td>{{out.methodName}}</td>
              <td>{{out.noOfRecords}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Account Owner Details'">
      <div class="col-12" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"   *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Customer Name</th>
              <th>Company Name</th>
              <th>Mobile</th>
              <th>Email</th>
            </tr>
            <tr *ngFor="let cd of orderList">
              <td>{{cd.ownerName}}</td>
              <td>{{cd.companyName}}</td>
              <td>{{cd.mobile}}</td>
              <td>{{cd.email}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Demand by SKU'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let dbs of orderList">
              <td style ="text-transform:uppercase;">{{dbs.sku}}</td>
              <td>{{dbs.productName}}</td>
              <td>{{dbs.productType | titlecase}}</td>
              <td>{{dbs.ownerName}}</td>
              <td>{{dbs.channelName | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf = "type =='Product Sales'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let rpl of orderList">
              <td  style ="text-transform:uppercase;">{{rpl.sku}}</td>
              <td>{{rpl.productName}}</td>
              <td>{{rpl.productType}}</td>
              <td>{{rpl.ownerName}}</td>
              <td>{{rpl.channelName | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf = "type =='Returned Products list'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
           <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let rpl of orderList">
              <td  style ="text-transform:uppercase;">{{rpl.sku}}</td>
              <td>{{rpl.productName}}</td>
              <td>{{rpl.productType}}</td>
              <td>{{rpl.ownerName}}</td>
              <td>{{rpl.channelName | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf = "type =='Inventory Reports'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mr-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
           <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style ="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>

            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>

    <div class="row mt-3" *ngIf = "type =='Low Stock Report'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
          <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
          <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
            <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
            <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
          </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style ="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{ (o.stockStatus == 'LOW_STOCK' ? 'Low Stock' : (o.stockStatus == 'IN_STOCK' ? 'In Stock' : o.stockStatus ))}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>

            </ng-container>

          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Out Of Stock Report'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style ="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{(o.stockStatus == 'OUT_OF_STOCK' ? 'Out Of Stock': o.stockStatus )}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>

            </ng-container>

          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Stock Status Report'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
           <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style ="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{(o.stockStatus == 'IN_STOCK' ? 'In Stock ': o.stockStatus )}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>

            </ng-container>

          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Inventory Adjustments'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-1 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Warehouse</th>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Owner Name</th>
              <th>Stock Status</th>
            </tr>
            <ng-container *ngFor="let om of orderList">
              <tr *ngFor="let o of om.productsList">
                <td>{{om.warehouseName}}</td>
                <td style ="text-transform:uppercase;">{{o.sku}}</td>
                <td>{{o.productName}}</td>
                <td>{{o.ownerName}}</td>
                <td>{{o.stockStatus | titlecase}}</td>
              </tr>
              <tr *ngIf="!om.productsList.length">
                <td>{{om.warehouseName}}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>

            </ng-container>

          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>


    <div class="row mt-3" *ngIf = "type =='Shipments'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style ="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>

            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Shipment Cost'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" class="col-1 text-right mb-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style ="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>

            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Shipped products'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>

          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Ordered Quantity</th>
              <th>Bin Location</th>
            </tr>
            <tr>
              <td style ="text-transform:uppercase;">{{'l.sku'}}</td>
              <td>{{'l.productName'}}</td>
              <td>{{'l.quantity'}}</td>
              <td>{{'l.binLocation'}}</td>

            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Account Snapshot'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
            </tr>
            <tr *ngFor="let dbs of orderList">
              <td style ="text-transform:uppercase;">{{dbs.sku}}</td>
              <td>{{dbs.productName}}</td>
              <td>{{dbs.productType}}</td>
              <td>{{dbs.ownerName}}</td>
              <td>{{dbs.channelName | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Customer details'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Owner Name</th>
              <th>Contact Company Name</th>
              <th>Contact Name</th>
              <th>Contact Mobile</th>
              <th>Contact Email</th>
            </tr>
            <tr *ngFor="let cd of orderList">
              <td>{{cd.ownerName}}</td>
              <td>{{cd.companyName}}</td>
              <td>{{cd.contactName}}</td>
              <td>{{cd.mobile}}</td>
              <td>{{cd.email}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Order all details'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>

          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let od of orderList">
              <td  style ="text-transform:uppercase;">{{od.sku}}</td>
              <td>{{od.productName}}</td>
              <td>{{od.productType}}</td>
              <td>{{od.ownerName}}</td>
              <td>{{od.channelName | titlecase}}</td>
              <td>{{od.stockStatus | titlecase}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Products'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Pdf" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToPdf()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <a  placement="bottom" ngbTooltip="Export To Excel" *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
           <!-- <div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Customer Name</th>
              <th>Channel Name</th>
              <th>Status</th>
            </tr>
            <tr *ngFor="let p of orderList">
              <td  style ="text-transform:uppercase;">{{p.sku}}</td>
              <td>{{p.productName}}</td>
              <td>{{p.productType}}</td>
              <td>{{p.ownerName}}</td>
              <td>{{p.channelName | titlecase}}</td>
              <td>{{(p.stockStatus == 'LOW_STOCK' ? 'Low Stock' : (p.stockStatus == 'OUT_OF_STOCK' ? 'Out Of Stock' :  (p.stockStatus == 'IN_STOCK' ? 'In Stock' : p.stockStatus )))}}</td>


            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Warehouse'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Excel" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Owner Name</th>
              <th>Contact Company Name</th>
              <th>Contact Name</th>
              <th>Contact Mobile</th>
              <th>Contact Email</th>
            </tr>
            <tr *ngFor="let cd of orderList">
              <td>{{cd.ownerName}}</td>
              <td>{{cd.companyName}}</td>
              <td>{{cd.contactName}}</td>
              <td>{{cd.mobile}}</td>
              <td>{{cd.email}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>

    </div>

    <div class="row mt-3" *ngIf = "type =='Report'">
      <div class="col" *ngIf= "orderList?.length>0">
        <div class="inner-box">

          <div class="row">
            <div class="col-6">
              <label><b>Reports</b></label>
            </div>
            <div class="col-6 text-right mb-2">
            <a  placement="bottom" ngbTooltip="Export To Excel" class="mr-2"  *ngIf= "orderList?.length">
              <svg xmlns="http://www.w3.org/2000/svg" (click)="exportToXLSX()" width="30" height="30" viewBox="0 0 30 30"><defs><style>.a{fill:#8a55bb!important;}.b{fill:#fff;}</style></defs><g transform="translate(4 2.5)"><rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/><path class="b" d="M14.9,2.152H9.814v.941h1.5V4.583h-1.5v.474h1.5V6.548h-1.5v.488h1.5v1.41h-1.5v.565h1.5v1.413h-1.5v.565h1.5v1.421h-1.5v1.037H14.9c.08-.024.147-.119.2-.283a1.387,1.387,0,0,0,.082-.4V2.324c0-.081-.028-.13-.082-.147A.7.7,0,0,0,14.9,2.152Zm-.66,10.257H11.8v-1.42h2.44v1.421Zm0-1.985H11.8V9.01h2.44Zm0-1.979H11.8v-1.4h2.44V8.447Zm0-1.9H11.8V5.058h2.44v1.49h0Zm0-1.973H11.8V3.094h2.44v1.48ZM0,1.918V13.685l8.958,1.549V.329L0,1.923Zm5.309,8.9q-.051-.139-.48-1.179c-.284-.693-.455-1.1-.505-1.212H4.309l-.961,2.287-1.284-.087L3.587,7.782,2.192,4.935,3.5,4.866l.865,2.227h.017l.977-2.329L6.714,4.68,5.1,7.76,6.764,10.9l-1.454-.085Z" transform="translate(3.386 5.171)"/></g></svg>
            </a>
            <!--<div class="col-6 text-right mb-2" *ngIf= "orderList?.length">
              <button type="button" (click)="exportToXLSX()" class="btn btn-outline-primary btn-sm ml-2">Export To Excel</button>
              <button *ngIf = "type !=='Low Stock Report' && type !=='Out Of Stock Report' && type !=='Stock Status Report' && type !=='Returned Products list'" type="button" (click)="exportToPdf()" class="btn btn-outline-primary btn-sm ml-2">Export To Pdf</button>
            </div>-->
          </div>
          </div>
          <table class="table">
            <tr>
              <th>Owner Name</th>
              <th>Contact Company Name</th>
              <th>Contact Name</th>
              <th>Contact Mobile</th>
              <th>Contact Email</th>
            </tr>
            <tr *ngFor="let cd of orderList">
              <td>{{cd.ownerName}}</td>
              <td>{{cd.companyName}}</td>
              <td>{{cd.contactName}}</td>
              <td>{{cd.mobile}}</td>
              <td>{{cd.email}}</td>
            </tr>
          </table>

        </div>
      </div>
      <div class="col-12 text-center" *ngIf="orderListLength">
        No data available
      </div>
    </div>
  </form>
</section>



